import { createClient } from "@/apollo/clientUtils";
import { createHttpLink } from "apollo-link-http";

const dataSourceLink = createHttpLink({
  uri: "/config-system/private/data"
});

export const config = createClient(dataSourceLink);
